import { ref } from 'vue'
import * as Request from '@/assets/request'

/**
 * 获取租户信息的 hooks
 * @returns {Object} 包含租户信息状态和方法
 */
export function useProductValid() {
  // 租户信息数据
  const tenantInfo = ref(null)
  const productValid = ref(null)

  /**
   * 获取租户信息
   */
  const getTenantInfo = () => Request.post({
    url: '/10067/tenant/getTenantSummary'
  }).then(res => {
    if (res?.code != 200) return;
    tenantInfo.value = res.data
    const result = res.data.appList.find(item => item.appId == 9)
    productValid.value = result
  })

  return {
    tenantInfo,
    productValid,
    getTenantInfo,
  }
}
